import PortfolioItemContext from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemContext';
import { type LogEntry, type UploadedImage } from '@/lib/types';
import { useContext } from 'react';
import UploadedImagesContext from '@/components/FileAttachments/UploadedImagesContext';
import type React from 'react';
import { type WritableDraft } from 'immer';

type LogEntryUploadedImagesContextProviderProps = {
  logEntry: LogEntry;
  children: React.ReactNode;
};

const LogEntryUploadedImagesContextProvider = ({
  logEntry,
  children,
}: LogEntryUploadedImagesContextProviderProps) => {
  const { setPortfolioItem, portfolioItemApiEndpoint } =
    useContext(PortfolioItemContext);

  return (
    <UploadedImagesContext.Provider
      value={{
        images: Object.values(logEntry.images),
        imagesEndpoint: `${portfolioItemApiEndpoint}/log-entries/${logEntry.id}/images`,
        addImageToLocalState: (image: UploadedImage): void => {
          setPortfolioItem(portfolioItem => {
            portfolioItem.logEntries[logEntry.id].images[image.id] = image;
          });
        },
        updateImageInLocalState: (
          image: UploadedImage,
          stateUpdater: (image: WritableDraft<UploadedImage>) => void,
        ): void => {
          setPortfolioItem(portfolioItem => {
            stateUpdater(
              portfolioItem.logEntries[logEntry.id].images[image.id],
            );
          });
        },
        removeImageFromLocalState: (image: UploadedImage): void => {
          setPortfolioItem(portfolioItem => {
            delete portfolioItem.logEntries[logEntry.id].images[image.id];
          });
        },
      }}
    >
      {children}
    </UploadedImagesContext.Provider>
  );
};

export default LogEntryUploadedImagesContextProvider;
